import { z } from "zod/v4";
import { createEndpointBase } from "./core";
import { KpiSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, KpiFilterSchema } from "../ea.schema.query";
import type { KpiStatistics } from "../ea.types";

const base = "kpis";
const kpis = createEndpointBase(base);
const stats = createEndpointBase(base, "statistics");

export const kpisEndpoints = {
  kpisGet: kpis({
    method: "GET",
    path: "",
    request: z.object({ filter: KpiFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(KpiSchemas["general"]),
    description: "Retrieves a list of KPI indicators with filtering support.",
  }),
  kpisCount: kpis({
    method: "GET",
    path: "count",
    request: z.any(),
    response: CountResponseSchema,
    description: "Returns the total number of KPI indicators matching the filters.",
  }),
  kpisCreate: kpis({
    method: "POST",
    path: "",
    request: KpiSchemas["createData"],
    response: KpiSchemas["general"],
    description: "Creates a new KPI indicator.",
  }),
  kpisUpdate: kpis({
    method: "PATCH",
    path: ":id",
    request: KpiSchemas["update"],
    response: KpiSchemas["general"],
    description: "Updates an existing KPI indicator.",
  }),
  kpisDelete: kpis({
    method: "DELETE",
    path: ":id",
    request: z.any(),
    response: z.any(),
    description: "Permanently deletes a KPI indicator.",
  }),

  kpisStatisticsExecution: stats({
    method: "GET",
    path: "execution",
    request: z.object({ executionIds: z.array(z.coerce.number()) }),
    response: z.any(),
    responseType: {} as KpiStatistics,
    description: "Retrieves KPI statistics for specific executions.",
  }),
  kpisStatisticsJob: stats({
    method: "GET",
    path: "job",
    request: z.object({ jobId: z.string() }),
    response: z.any(),
    responseType: {} as KpiStatistics,
    description: "Retrieves KPI statistics for a specific job.",
  }),
} as const;
